<template>
    <div class="component__breadcrumbs">
        <nav class="component__breadcrumbs_nav">
            <template
                v-for="(item, index) in items"
            >
                <router-link
                    :to="item.to"
                    :key="index"
                >{{ item.name }}</router-link>
                <v-icon
                    v-if="index !== (items.length - 1)"
                    name="chevron-right"
                    :key="`${index}-icon`"
                ></v-icon>
            </template>
        </nav>
    </div>
</template>

<script>
export default {
  name: 'component-breadcrumbs',
  props: {
    // each object requires name & to keys
    items: {
      type: [Array, Object],
      default: () => []
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentbreadcrumbs";
</style>
